export default __webpack_public_path__ + "static/media/casino.go.hvid.trans.4306217e.svg";